// import Docxtemplater from "docxtemplater";
import Docxtemplater from "docxtemplater";
// import PizZip from "pizzip";
import PizZip from "pizzip";
import { loadFile } from "./helpers";

function errorHandler(error) {
  if (error.properties && error.properties.errors instanceof Array) {
    const errorMessages = error.properties.errors
      .map(function (error) {
        return error.properties.explanation;
      })
      .join("\n");
    console.log("errorMessages", errorMessages);
  }
  throw error;
}

export const generateDocx = (file, data, fromInput) => {
  return new Promise(function (resolve) {
    loadFile(fromInput, file, function (error, content) {
      if (error) {
        throw error;
      }
      let pizzip = new PizZip(content);
      let generate = new Docxtemplater(pizzip, { paragraphLoop: true, linebreaks: true });
      try {
        generate.setData(data);
        generate.render();
      } catch (error) {
        errorHandler(error);
      }
      let output = generate.getZip().generate({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      resolve(output);
    });
  });
};
